<template>
  <MembershipsSold v-if="!showTabs && initialData" v-bind="initialData" />

  <Page v-else-if="initialData" title="Memberships">
    <TabSwitcher id="memberships" :tabs="tabs" />
  </Page>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from "vue";
import { useFeatureFlag } from "@/lib/useFeatureFlag";

import Page from "@/components/Page.vue";
import TabSwitcher from "@/components/TabSwitcher/TabSwitcher.vue";
import MembershipsSold from "@/Reports/MembershipsSold.vue";
import PaymentActivity from "@/Reports/PaymentActivity.vue";

const showTabs = useFeatureFlag("membership_tabs_enabled");

const initialData = ref<{
  filters: [];
  source: string;
} | null>(null);

const tabs = computed(() => [
  {
    name: "Membership To-Do",
    component: MembershipsSold,
    props: initialData.value
  },
  {
    name: "Payment Activity",
    component: PaymentActivity
  }
]);

onMounted(async () => {
  const url = `${window.location.origin}${window.location.pathname}/initial_page_data`;
  const res = await fetch(url, {
    method: "GET"
  });
  initialData.value = await res.json();
});
</script>
